//@flow

export const throwError = (message: string) => {
  throw Error(message)
}
